import Link from "next/link";
import { getCategory } from "@/lib/scenes";

/** Pastilles de couleur par token DA - classes littérales pour la purge Tailwind */
const dotColors: Record<string, string> = {
  lagon: "bg-lagon",
  tropical: "bg-tropical",
  volcan: "bg-volcan",
  or: "bg-or",
  ocean: "bg-ocean",
  mineral: "bg-mineral",
};

export default function CategoryBadge({
  categoryId,
  asLink = false,
}: {
  categoryId: string;
  /** true : renvoie vers la page catégorie (maillage interne) */
  asLink?: boolean;
}) {
  const cat = getCategory(categoryId);
  if (!cat) return null;
  const inner = (
    <>
      <i
        aria-hidden
        className={`h-1.5 w-1.5 rounded-full ${dotColors[cat.color] ?? "bg-mineral"}`}
      />
      {cat.label}
    </>
  );
  const cls =
    "inline-flex items-center gap-1.5 rounded-full bg-basalte/70 px-2.5 py-1 text-[10.5px] tracking-[0.09em] uppercase backdrop-blur-sm";
  if (asLink) {
    return (
      <Link href={`/categorie/${cat.id}/`} className={`${cls} transition-colors hover:text-or`}>
        {inner}
      </Link>
    );
  }
  return <span className={cls}>{inner}</span>;
}
